// extracted by mini-css-extract-plugin
export default {"root":"CustomLink_root__ltMjw"};